import { render } from "./GameIsOn.vue?vue&type=template&id=305ce6e2&scoped=true"
import script from "./GameIsOn.vue?vue&type=script&lang=js"
export * from "./GameIsOn.vue?vue&type=script&lang=js"

import "./GameIsOn.vue?vue&type=style&index=0&id=305ce6e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305ce6e2"]])

export default __exports__